{
	"title": "Commenti",
	"statuses": {
		"inValidation": "In validazione",
		"rejected": "Rifiutato",
		"assured": "Confermato",
		"flagged": "Segnalato",
		"resolved": "Risolto"
	}
}
